<template>
    <v-container
        id="vacation"
        fluid
    >
        <v-row>
            <v-col cols="12">
                <v-subheader class="vacation-header">
                    {{ vacationText }}                    
                </v-subheader>                
            </v-col>
        </v-row>
        <v-row v-if="enableAddVacation">
            <v-col>
                <v-toolbar
                    id="vacation-toolbar"
                    flat
                >
                    <v-row>
                        <v-col
                            cols="6"
                        />
                        <v-col
                            cols="6"
                            class="text-right"
                        >
                            <AddVacation
                                model-type="Add"
                                @save-vacation="saveVacation"
                            />
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    :headers="headers"
                    :items="vacations"
                    class="elevation-0"
                    dense
                    hide-default-footer
                >
                    <template v-slot:[`item.startDate`]="{item}">                        
                        <span class="date-time-field">{{ formatDate(item.startDate) }}</span>
                    </template>
                    <template v-slot:[`item.startTime`]="{item}">
                        <span class="date-time-field">{{ formatTime(item.startDate) }}</span>
                    </template>
                    <template v-slot:[`item.endDate`]="{item}">
                        <span class="date-time-field">{{ formatDate(item.endDate) }}</span>
                    </template>
                    <template v-slot:[`item.endTime`]="{item}">
                        <span class="date-time-field">{{ formatTime(item.endDate) }}</span>
                    </template>
                    <template v-slot:[`item.edit`]="{item}">
                        <AddVacation
                            :start-date="item.startDate"
                            :end-date="item.endDate"                            
                            :vacation="item.vacationNumber"
                            model-type="Edit"
                            @save-vacation="saveVacation"
                        />
                    </template>
                    <template v-slot:[`item.delete`]="{item}">
                        <DeleteVacation
                            model-type="DeleteIcon"
                            :vacation="item.vacationNumber"
                            @delete-vacation="deleteVacation"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>               
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import AddVacation from './AddVacation.vue';
import DeleteVacation from './DeleteVacation.vue';
import dayjs from 'dayjs';

export default {
    name: 'Vacation',
    components: {
        AddVacation,
        DeleteVacation       
    },
    data() {
        return {
            currentTab: 'vacation',
            vacationText: `You can optionally specify up to five vacation date ranges for this Locator. During these periods, the Auto-Assign system will not assign tickets to this Locator.`,
            enableAddVacation: true,
            dialog: false,
            datetime: null,
            fromDateTime: null,
            toDateTime: null,           
            vacations: [],
            VACATION1: '',
            VACATION2: '',
            VACATION3: '',
            VACATION4: '',
            VACATION5: '',
            headers: [
                {
                    text: 'Start Date',
                    align: 'start',
                    sortable: false,
                    value: 'startDate'
                },
                {
                    text: 'Start Time',
                    align: 'start',
                    sortable: false,
                    value: 'startTime'
                },
                {   text: 'End Date',
                    align: 'start',
                    sortable: false,
                    value: 'endDate'
                },
                {   text: 'End Time',
                    align: 'start',
                    sortable: false,
                    value: 'endTime' 
                },
                {
                    text: 'Edit',
                    align: 'center',
                    value: 'edit',
                    sortable: false,
                },
                {
                    text: 'Delete',
                    align: 'center',
                    value: 'delete',
                    sortable: false,
                }
            ]           
        };
    },    
    computed: {
        getEditUser() {
            return this.$store.getters.editUser;
        },
        getUserPermissions() {
            return this.$store.getters.userPermissions;
        },
        getCompnay() {
            return this.$store.getters.company;
        },
    },
    created() {       
        this.setFormData();
    },
    methods: {
        setFormData() {            
            if(this.$route.query.id) { 
                this.isEditUser = true;
                this.getEditUserVacation();
            }
        },
        async saveUser() {
            if(this.getEditUser.account) {
                this.getEditUser.account = this.getEditUser.account.toUpperCase();
            }
            let payload = {
                account: this.getEditUser.account,
                cid: this.getCompnay.cid,
                ingroup: this.getEditUser.ingroup,
                name: this.getEditUser.name,
                password: this.getEditUser.password,
                passwordConfirm: this.getEditUser.passwordConfirm
            };

            try {
                this.$emit('start-loader');
                let result = await webtmsBackend.addUser(payload);
                if(result.err) {
                    this.$emit('stop-loader');
                    throw result.err;
                }
                if(result.result === 'OK') {
                    let userObject = await webtmsBackend.getUser(result.uid);
                    if(userObject) {
                        if(this.getEditUser.company === '') {
                            this.getEditUser.company = userObject.company;
                        }
                        this.getEditUser.account = userObject.account;
                        userObject = { ...userObject, ...this.getEditUser };
                        delete userObject.userCompanies;
                        delete userObject.RECEIVE_OVERDUE_NOTIFICATION;
                        delete userObject.RECEIVE_COMPANY_EOD_AUDIT;
                        delete userObject.RECEIVE_COMPANY_EOD_REPORT;
                        delete userObject.RECEIVE_SYSTEM_SOD;
                        delete userObject.RECEIVE_SYSTEM_EOD;
                        delete userObject.RECEIVE_SYSTEM_CHECK_ERRORS;
                        delete userObject.RECEIVE_OVERDUE_NOTIFICATION_INTERVAL;
                        delete userObject.ALTERNATE_LOCATOR;
                        delete userObject.ASSIGNED_TICKET_LIMIT;
                        delete userObject.ASSIGNMENT_ON_HOLD;
                        delete userObject.FORCE_ALTERNATE_LOCATOR;
                        delete userObject.EMAIL_ASSIGNED_TICKETS;
                        delete userObject.VACATION1;
                        delete userObject.VACATION2;
                        delete userObject.VACATION3;
                        delete userObject.VACATION4;
                        delete userObject.VACATION5;
                        delete userObject.user_level;
                        
                        let updateUserResponse = await webtmsBackend.updateUser({uid: result.uid, ...userObject});
                        if(updateUserResponse.status === 'OK') {
                            this.$emit('stop-loader');
                            this.$store.dispatch('setSnackbar', { text: `User account "${updateUserResponse.user.name}" created successfully.` });
                            this.$store.commit('SET_EDIT_USER', null);
                            this.$router.push('users');
                        }
                        if(updateUserResponse.err) {
                            this.$emit('stop-loader');
                            this.$store.dispatch('setSnackbar', { color:'error', text: updateUserResponse.err });
                            this.$store.commit('SET_EDIT_USER', null);
                            this.$router.push('users');
                        }
                    }
                }
            } catch(error) {
                this.$emit('stop-loader');
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
                this.$store.commit('SET_EDIT_USER', null);
                this.$router.push('users');
            }
        },
        async editUser() {            
            try{
                this.saveVacation();
                let result = await webtmsBackend.updateUser({uid: this.$route.query.id, ...this.getEditUser});
                if(result.status === 'OK') {
                    if(this.getEditUser.account === this.getUserDetails.account) {
                        const getUserResult = await webtmsBackend.getUserObject(this.getUserDetails.uid);
                        this.$store.commit('SET_USER', getUserResult);
                    }
                    this.$store.dispatch('setSnackbar', { text: `User account "${result.user.name}" updated successfully.` });
                    this.$store.commit('SET_EDIT_USER', null);
                    this.$router.push('users');
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } catch(error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
            }
        },
        getEditUserVacation() {
            this.vacations = [];

            if (!this.getEditUser?.userOptions) {
                return;
            }
            for (let i = 1; i <= 5; i++) {
                const property = `VACATION${i}`;
                const option = this.getOptionObject(property);                
                if (option?.value) {
                    const [startDate, endDate] = option.value.split('|');
                    this.vacations.push({
                        vacationNumber: property,
                        startDate: new Date(startDate),
                        endDate: new Date(endDate),
                    });
                }
            }
            // disable add vacation button if all 5 vacations are added
            this.enableAddVacation = this.vacations.length < 5;

        },
        getOptionObject(property) {
            // alert('getOptionObject');
            return this.getEditUser.userOptions.find(option => option.option === property);
        },
        saveVacation(vacation) {
            if(!vacation) {
                return;
            }
            for (let i = 1; i <= 5; i++) {
                let property = `VACATION${i}`;
                let userOption = this.getEditUser.userOptions.find(o => o.option === property);
                // if (userOption === undefined) {
                //     this.getEditUser.userOptions.push({ 
                //         'default':'',
                //         'description':property,
                //         'option': property,
                //         'value': '' });
                //     userOption = this.getEditUser.userOptions.find(o => o.option === property); 
                // }                
                
                let isVacationEmpty = userOption.value === '';
                let isVacationBeingEdited = !isVacationEmpty && vacation.mode === 'Edit' && vacation.vacationNumber === property;
                if ((isVacationEmpty && vacation.mode === 'Add') || isVacationBeingEdited) {
                    let formattedVacation = `${this.formatDate(vacation.start_date)} ${vacation.start_time}|${this.formatDate(vacation.end_date)} ${vacation.end_time}`;
                    if (userOption) {
                        userOption.value = formattedVacation;
                    // } else {
                    //     this.getEditUser.userOptions.push({ property, formattedVacation });
                    }
                    this.getEditUserVacation();
                    break;
                }
            }           
        },
        deleteVacation(vacation) {
            const userOption = this.getEditUser.userOptions.find(o => o.option === vacation);
            userOption.value = '';
            this.getEditUserVacation();
        },
        getUserDetails() {
            return this.$store.getters.user;
        },
        formatDate(date) {
            return dayjs(date).format('MM/DD/YYYY');         
        },
        formatTime(time) {
            return dayjs(time).format('hh:mm A'); 
        },
    }
};
</script>

<style>
.vacation-header {
  font-size: 18px;
  margin: 10px 0px 10px 0px;
  /* font-weight: bold; */
}
.date-time-field {
  white-space: nowrap;
}
</style>    